/** Ошибки ключа пользователя: сообщение Error — код из этого перечисления */
export enum EnumUserKeyError {
  /** Строка испорчена или ключ данных зашифрован ключом другой учётной записи */
  WRONG_KEY = 'wrong_key',
}
